import type { ReactNode } from 'react';
import { css, cx } from '@eti/styles';

interface IconWrapperProps {
  children: ReactNode;
  hasWhiteBackground?: boolean;
}

interface TripDetailsWrapperProps {
  children: ReactNode;
  className?: string;
}

const iconWrapperStyles = (hasWhiteBackground?: boolean) => css`
  align-items: center;
  display: flex;
  justify-content: center;
  min-width: 19px;
  ${hasWhiteBackground && `background-color: #fff`};
  z-index: 2;
`;

const tripDetailsWrapperStyles = css`
  align-items: center;
  display: flex;
  padding-block: 16px;
  position: relative;
`;

export const boundMargins = css`
  content: '';
  height: 50%;
  margin-inline-start: 98px;
  position: absolute;
  z-index: 1;
`;

export const IconWrapper = ({ children, hasWhiteBackground }: IconWrapperProps) => (
  <div className={iconWrapperStyles(hasWhiteBackground)}>{children}</div>
);

export const TripDetailsWrapper = ({ children, className, ...rest }: TripDetailsWrapperProps) => (
  <div className={cx(tripDetailsWrapperStyles, className)} {...rest}>
    {children}
  </div>
);
